// src/pages/Profile.js
import TopLogout from "../components/TopLogout";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BottomNav from "../components/BottomNav";

/* 🔴 FIREBASE COMPLETELY REMOVED */

export default function Profile() {
  const navigate = useNavigate();

  const [loggedInEmail, setLoggedInEmail] = useState("");
  const [oldPass, setOldPass] = useState("");
  const [newPass, setNewPass] = useState("");
  const [newUserEmail, setNewUserEmail] = useState("");
  const [newUserPass, setNewUserPass] = useState("");

  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showNewUserPass, setShowNewUserPass] = useState(false);

  const [changing, setChanging] = useState(false);
  const [addingUser, setAddingUser] = useState(false);
  const [loggingOut, setLoggingOut] = useState(false);

  /* ✅ LOAD LOGGED-IN USER */
  useEffect(() => {
    const email = localStorage.getItem("smartagri_user_email");
    setLoggedInEmail(email || "Not signed in");
  }, []);

  /* ✅ CHANGE PASSWORD */
  const handleChangePassword = async () => {
    if (!oldPass || !newPass) {
      alert("Fill both old & new passwords.");
      return;
    }

    setChanging(true);
    try {
      const res = await fetch(
        "https://laturelectronics.in/smartagri_api/change_password.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email: loggedInEmail,
            old_password: oldPass,
            new_password: newPass,
          }),
        }
      );

      const data = await res.json();

      if (data.status === "success") {
        alert("Password updated successfully!");
        setOldPass("");
        setNewPass("");
      } else {
        alert(data.message || "Failed to update password");
      }
    } catch (err) {
      console.error(err);
      alert("Server error");
    } finally {
      setChanging(false);
    }
  };

  /* ✅ ADD NEW USER */
  const handleAddUser = async () => {
    if (!newUserEmail || !newUserPass) {
      alert("Enter new user's email & password.");
      return;
    }

    setAddingUser(true);
    try {
      const res = await fetch(
        "https://laturelectronics.in/smartagri_api/add_user.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email: newUserEmail,
            password: newUserPass,
          }),
        }
      );

      const data = await res.json();

      if (data.status === "success") {
        alert("New user added successfully!");
        setNewUserEmail("");
        setNewUserPass("");
      } else {
        alert(data.message || "Failed to add user");
      }
    } catch (err) {
      console.error(err);
      alert("Server error");
    } finally {
      setAddingUser(false);
    }
  };

  /* ✅ LOGOUT */
  const handleLogout = () => {
    setLoggingOut(true);
    localStorage.removeItem("smartagri_logged_in");
    localStorage.removeItem("smartagri_user_email");
    navigate("/");
  };

  return (
    <div style={styles.bg}>
      <img src="/com_logo.png" alt="Company Logo" style={styles.companyLogo} />

      <div style={styles.overlay}>
        <TopLogout />
        <h1 style={styles.title}>Profile</h1>

        <div style={styles.card}>
          <h3>Logged in as:</h3>
          <p>{loggedInEmail}</p>
        </div>

        <div style={styles.card}>
          <h3>Change Password</h3>

          <div style={{ position: "relative" }}>
            <input
              type={showOld ? "text" : "password"}
              placeholder="Old Password"
              style={styles.input}
              value={oldPass}
              onChange={(e) => setOldPass(e.target.value)}
            />
            <span style={styles.showText} onClick={() => setShowOld(!showOld)}>
              {showOld ? "Hide" : "Show"}
            </span>
          </div>

          <div style={{ position: "relative" }}>
            <input
              type={showNew ? "text" : "password"}
              placeholder="New Password"
              style={styles.input}
              value={newPass}
              onChange={(e) => setNewPass(e.target.value)}
            />
            <span style={styles.showText} onClick={() => setShowNew(!showNew)}>
              {showNew ? "Hide" : "Show"}
            </span>
          </div>

          <button
            style={styles.btn}
            onClick={handleChangePassword}
            disabled={changing}
          >
            {changing ? "Updating..." : "Update Password"}
          </button>
        </div>

        <div style={styles.card}>
          <h3>Add New User</h3>

          <input
            type="email"
            placeholder="New User Email"
            style={styles.input}
            value={newUserEmail}
            onChange={(e) => setNewUserEmail(e.target.value)}
          />

          <div style={{ position: "relative" }}>
            <input
              type={showNewUserPass ? "text" : "password"}
              placeholder="New User Password"
              style={styles.input}
              value={newUserPass}
              onChange={(e) => setNewUserPass(e.target.value)}
            />
            <span
              style={styles.showText}
              onClick={() => setShowNewUserPass(!showNewUserPass)}
            >
              {showNewUserPass ? "Hide" : "Show"}
            </span>
          </div>

          <button
            style={styles.btn}
            onClick={handleAddUser}
            disabled={addingUser}
          >
            {addingUser ? "Creating..." : "Add User"}
          </button>
        </div>

        <div style={styles.card}>
          <button
            style={styles.logoutBtn}
            onClick={handleLogout}
            disabled={loggingOut}
          >
            {loggingOut ? "Signing out..." : "Logout"}
          </button>
        </div>
      </div>

      <BottomNav />
    </div>
  );
}

/* ---------- STYLES (FIXED WITHOUT DESIGN CHANGE) ---------- */
const styles = {
  bg: {
    backgroundImage: "url('/bg5.png')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    minHeight: "100vh",
  },
  companyLogo: {
    position: "absolute",
    top: "10px",
    left: "10px",
    width: "140px",
    zIndex: 1000,
  },
  overlay: {
    background: "rgba(0,0,0,0.55)",
    minHeight: "100vh",
    padding: "20px",
    paddingBottom: "90px",
    textAlign: "center",
    color: "white",
  },
  title: {
    fontSize: "32px",
    fontWeight: "bold",
    marginBottom: "20px",
    color: "#a8ff60",
  },
  card: {
    background: "rgba(0,0,0,0.60)",
    borderRadius: "14px",
    padding: "22px",
    marginBottom: "40px",
    maxWidth: "450px",
    marginLeft: "auto",
    marginRight: "auto",
  },
  input: {
    width: "100%",
    padding: "10px",
    borderRadius: "10px",
    border: "none",
    marginTop: "10px",
    fontSize: "15px",
  },
  btn: {
    background: "#00c853",
    padding: "10px 20px",
    borderRadius: "10px",
    color: "white",
    border: "none",
    cursor: "pointer",
    width: "100%",
    marginTop: "10px",
    fontSize: "16px",
  },
  logoutBtn: {
    background: "#ff5252",
    padding: "10px 20px",
    borderRadius: "10px",
    color: "white",
    border: "none",
    cursor: "pointer",
    width: "100%",
    fontSize: "17px",
    fontWeight: "600",
  },
  showText: {
    position: "absolute",
    right: "12px",
    top: "14px",
    fontSize: "13px",
    cursor: "pointer",
    color: "#007bff",
    fontWeight: "600",
  },
};
